<template>
  <div>
    <BaseButton
        size="medium"
        @click="newRegister">
      新規
    </BaseButton>
  </div>
</template>

<script>
import * as define from '@/define'

import BaseButton from '@/components/atoms/BaseButton'

export default {
  name: 'BaseNewRegisterButton',
  components: {
    BaseButton
  },
  props: {
    storePath: {
      type: String,
      default: null
    },
    url: {
      type: String,
      default: null
    }
  },
  methods: {
    newRegister () {
      const mode = this.storePath + '/mode'
      const returnList = this.storePath + '/returnList'
      this.$store.dispatch({
        type: 'set',
        states: {
          [mode]: define.MODE.NEW,
          [returnList]: true
        }
      })
      this.$router.push({ path: this.url + '/new' })
    }
  }
}
</script>
